import React from "react"

const FutureHuddleSkeleton = ({ sidebarOpen }) => {
	return (
		<div className={`${sidebarOpen ? "pl-64" : "pl-8"}`}>
			{/* Header Skeleton */}
			<div className="my-5 flex h-auto sm:h-16 flex-col sm:flex-row items-start sm:items-center justify-between bg-white px-4 sm:px-6 lg:px-8 print-hidden">
				<div className="h-10 bg-gray-200 rounded w-48 animate-pulse mb-4 sm:mb-0"></div>
			</div>

			<div className="px-4 sm:px-6 lg:px-8">
				{/* Summary Section Skeleton */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 mt-8">
					{[1, 2, 3].map(i => (
						<div
							key={i}
							className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse"
						>
							<div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
							<div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
							<div className="h-4 bg-gray-200 rounded w-2/3"></div>
						</div>
					))}
				</div>

				{/* Day Overview Skeleton */}
				<div className="mt-8">
					<div className="flex items-center justify-between mb-6">
						<div className="flex items-center">
							<div className="w-6 h-6 bg-gray-200 rounded mr-2 animate-pulse"></div>
							<div className="h-6 bg-gray-200 rounded w-32 animate-pulse"></div>
						</div>
						<div className="flex items-center space-x-2">
							<div className="h-8 bg-gray-200 rounded w-20 animate-pulse"></div>
							<div className="h-8 bg-gray-200 rounded w-20 animate-pulse"></div>
						</div>
					</div>
					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
						{[1, 2, 3, 4, 5, 6].map(i => (
							<div
								key={i}
								className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse"
							>
								<div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
								<div className="h-8 bg-gray-200 rounded w-3/4 mb-2"></div>
								<div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
								<div className="h-4 bg-gray-200 rounded w-1/2"></div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}

export default FutureHuddleSkeleton
